import { cn } from "@/lib/utils";
import { useTranslation } from "react-i18next";

export default function ThreeDotLoader({ size = "md", color = "primary" }) {
  const { t } = useTranslation();
  const sizeClasses = {
    sm: "h-1 w-1",
    md: "h-2 w-2",
    lg: "h-3 w-3",
  };

  const containerSizeClasses = {
    sm: "h-4 w-16",
    md: "h-8 w-20",
    lg: "h-12 w-24",
  };

  const colorClasses = {
    primary: "bg-primary",
    secondary: "bg-secondary",
    accent: "bg-background",
    success: "bg-success",
    warning: "bg-warning",
    error: "bg-error",
  };

  return (
    <div
      className={cn(
        "flex items-center justify-center",
        containerSizeClasses[size]
      )}
      role="status"
      aria-label="loading"
    >
      <div className="flex gap-3">
        {[0, 1, 2].map((index) => (
          <div
            key={index}
            className={cn(
              "rounded-full animate-bounce",
              sizeClasses[size],
              colorClasses[color]
            )}
            style={{
              animationDelay: `${index * 0.1}s`,
              animationDuration: "0.6s",
            }}
          />
        ))}
      </div>
      <span className="sr-only">{t("common.loading")}</span>
    </div>
  );
}
